// 这东西就不能维护个服务器的字典吗
export const rule = [
  {
    label: '包含',
    value: 1
  },
  {
    label: '正则表达式',
    value: 3
  },
  {
    label: '等于',
    value: 4
  },
  {
    label: '不等于',
    value: 5
  },
  {
    label: '不包含',
    value: 6
  }
]

export const userRule = [
  {
    label: '用户类型',
    value: 0
  },
  {
    label: '国家/地区/城市',
    value: 1
  }
]

export let userTypeRule = []
userTypeRule[0] = [
  {
    label: '新访',
    value: '1'
  },
  {
    label: '老访',
    value: '0'
  },
  {
    label: '年轻用户',
    value: '3'
  }
  // ,
  // {
  //   label: '非年轻用户',
  //   value: '4'
  // }
  // {
  //   label: '新客',
  //   value: '3'
  // },
  // {
  //   label: '老客',
  //   value: '4'
  // }
]
userTypeRule[1] = [
  {
    label: '主数据',
    value: 1
  },
  {
    label: '主数据B',
    value: 2
  }
]
